<template>
  <v-card text xs12>
    <v-data-table
      :headers="headers"
      :items="files"
      :search="search"
      v-model="selected"
      item-key="id"
      class="elevation-1"
      :pagination.sync="pagination"
      :loading="spinner"
      hide-actions
    >
      <template
        slot="headerCell"
        slot-scope="props"
      >
        <span>
          {{ props.header.text }}
        </span>
      </template>
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <!-- <td class="text-xs-left">
            <v-btn
              v-if="!props.expanded"
              icon small class="mx-0"
              :ripple="{ class: 'error--text' }"
              @click="props.expanded = !props.expanded"
            >
              <v-icon small color="grey darken-1">
                keyboard_arrow_down
              </v-icon>
            </v-btn>
            <v-btn
              v-else
              icon
              small
              class="mx-0"
              :ripple="{ class: 'error--text' }"
              @click="props.expanded = !props.expanded"
            >
              <v-icon small color="grey darken-1">
                keyboard_arrow_up
              </v-icon>
            </v-btn>
          </td> -->
          <td
            class="text-xs-left"
          >
            {{ props.item.list }}
          </td>
          <td class="text-xs-right">
            <v-btn
              v-if="props.item.active"
              icon
              small
              class="mx-0"
              :ripple="{ class: 'error--text' }"
              @click="startStopCampaign(props.item.id)"
            >
              <v-icon small color="grey darken-1">
                pause
              </v-icon>
            </v-btn>
            <v-btn
              v-else
              icon
              small
              class="mx-0"
              :ripple="{ class: 'error--text' }"
              @click="startStopCampaign(props.item.id)"
            >
              <v-icon small color="grey darken-1">
                play_arrow
              </v-icon>
            </v-btn>
          </td>
          <td class="text-xs-right" v-if="props.item.insights.spend">{{ props.item.insights.spend | currency }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.reach">{{ props.item.insights.reach | thousands }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.total_actions">{{ props.item.insights.total_actions | thousands }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.cost_per_total_action">{{ props.item.insights.cost_per_total_action | currency }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.clicks">{{ props.item.insights.clicks | thousands }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.cpc">{{ props.item.insights.cpc | currency }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.impressions">{{ props.item.insights.impressions | thousands }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.cpm">{{ props.item.insights.cpm | currency }}</td>
          <td class="text-xs-right" v-else>-</td>
          <td class="text-xs-right" v-if="props.item.insights.ctr">{{ props.item.insights.ctr | percent }}</td>
          <td class="text-xs-right" v-else>-</td>
        </tr>
      </template>
      <template slot="expand" slot-scope="props">
        <!-- <v-layout
          row
          justify-end
          class="expand-panel"
        >
          <v-flex xs2 offset-xs6>
            <highcharts :options="props.item.options"></highcharts>
          </v-flex>
          <v-flex xs2>
            <highcharts :options="props.item.options"></highcharts>
          </v-flex>
          <v-flex xs2>
            <highcharts :options="props.item.options"></highcharts>
          </v-flex>
        </v-layout> -->
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2">
      <v-pagination v-model="pagination.page" :length="pages" v-show="pages > 1"></v-pagination>
    </div>
  </v-card>
</template>

<script>
  export default {
    name: 'audiences-report-table',
    data () {
      return {
        search: '',
        pagination: {},
        selected: [],
        headers: [
          // { text: '', align: 'center', value: 'icon', width: '20px', sortable: false },
          { text: 'Audience', align: 'left', value: 'list' },
          { text: ' ', align: 'right', value: 'edit', sortable: false },
          { text: 'Budget Spent', align: 'right', value: 'spend' },
          { text: 'Reach', align: 'right', value: 'reach' },
          { text: 'Actions', align: 'right', value: 'total_actions' },
          { text: 'Cost per Action', align: 'right', value: 'cost_per_total_action' },
          { text: 'Clicks', align: 'right', value: 'clicks' },
          { text: 'Cost per Click', align: 'right', value: 'cpc' },
          { text: 'Impressions', align: 'right', value: 'impressions' },
          { text: 'CPM', align: 'right', value: 'cpm' },
          { text: 'CTR', align: 'right', value: 'ctr' }
        ]
      }
    },
    props: {
      files: {
        type: Array,
        default: () => []
      }
    },
    filters: {
      thousands: function (number) {
        return Number(number).toLocaleString()
      },
      currency: function (number) {
        return '$' + parseFloat(number).toFixed(2)
      },
      percent: function (number) {
        return parseFloat(number).toFixed(1) + '%'
      }
    },
    computed: {
      spinner () {
        return this.$store.getters.getSpinner
      },
      pages () {
        if (this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) return 0
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
      },
      audiences () {
        return this.$store.getters.getAudiences
      },
      campaigns () {
        return this.$store.getters.getCampaigns
      },
      campaignAudiences () {
        return []
      }
    },
    methods: {
      startStopCampaign (id) {
        this.$emit('startStopCampaign', id)
      }
    }
  }
</script>
<style>
  .table tbody tr {
    cursor: pointer;
  }
  .table tbody tr[active] {
    background: #a5d6a7!important;
  }
  .expand-panel .highcharts-container {
    width: 100%;
    max-height: 200px!important;
  }
  .highcharts-root{
    max-height: 100%;
  }
  .datatable__expand-content tr:hover {
    background: #FFFFFF!important;
  }
</style>
